import { useMutation } from '@tanstack/react-query';
import { updateUserHabitGroupBy } from 'shared/services/backend-api';
import { HabitGroupBy } from 'shared/types/sorting-mode';

export const useUpdateHabitGroupByMutation = () =>
  useMutation({
    mutationFn: async (groupBy: HabitGroupBy) =>
      updateUserHabitGroupBy(groupBy),
  });
